export enum AsyncRules {
    editResource = 'corpus.editResource',
}